import { Helmet } from 'react-helmet-async';
import '../App.css';
import { Header, Footer, FaqSection, FinalCta, useRevealObserver, FAQS } from '../sections';

function FaqPage(): JSX.Element {
  useRevealObserver();

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };

  return (
    <div className="splash-root">
      <Helmet defer={false}>
        <title>Game Localization FAQ — Loten Labs</title>
        <meta name="description" content="Answers on context handling, engines, IP safety, patch cycles, live-ops drops, linguist staffing, and integration with your repo." />
        <link rel="canonical" href="https://useloten.com/faq" />
        <meta property="og:title" content="Game Localization FAQ — Loten Labs" />
        <meta property="og:description" content="Answers on context handling, engines, IP safety, patch cycles, live-ops drops, linguist staffing, and integration with your repo." />
        <meta property="og:url" content="https://useloten.com/faq" />
        <meta name="twitter:title" content="Game Localization FAQ — Loten Labs" />
        <meta name="twitter:description" content="Answers on context handling, engines, IP safety, patch cycles, live-ops drops, linguist staffing, and integration with your repo." />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>
      <a className="skip-link" href="#main-content">Skip to main content</a>

      <Header />

      <main id="main-content">
        <FaqSection
          heading="Frequently asked questions"
          subtitle="What producers and founder-designers ask us most."
        />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}

export default FaqPage;
